const state = {
  token: "",
};

const getters = {
  token: (state) => {
    return state.token;
  },
};

const mutations = {
  setToken: (state, token) => {
    state.token = token;
  },
};

const actions = {
  updateToken: (context, token) => {
    context.commit("setToken", token);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
